/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

import isInputCorrect from "src/utils/ResultValidationHelper";

import ResultDropdown from "src/components/dropdowns/Result.react";

import {
  Table,
  ColHeader,
  TableBody,
  Col,
} from "src/components/tables/Table.react";
import ResultBadge from "src/components/badges/Result.react";

/**
 * The InsulationResistance component
 *
 * @author Thais Watanabe
 */
const InsulationResistance = (props) => {
  const {
    turbineInspection,
    title,
    inspectionModel,
    result,
    openEdit,
    openObs,
    isPastInspection,
    inspection,
    lastTurbineInspections,
  } = props;

  return (
    <div className="flex flex-col gap-y-5 print:gap-y-2">
      <Table>
        <thead>
          <tr>
            <ColHeader
              id={inspectionModel?.name}
              className="w-10 text-center print:hidden"
              rowSpan={2}
            >
              {!isPastInspection && (
                <ResultDropdown
                  openEdit={openEdit}
                  openObs={openObs}
                  selectedItem={inspectionModel}
                  turbineInspection={turbineInspection}
                  selectedResult={result}
                  lastTurbineInspections={lastTurbineInspections}
                  inspection={inspection}
                />
              )}
            </ColHeader>
            <ColHeader className="text-center" colSpan={3}>
              {title}
            </ColHeader>
          </tr>
          <tr>
            <ColHeader className="text-center">測定場所</ColHeader>
            <ColHeader className="text-center">測定値</ColHeader>
            <ColHeader className="text-center">試験電圧</ColHeader>
          </tr>
        </thead>
        <TableBody>
          {[...Array(6)].map((_, i) => (
            <tr key={`x-${i}`}>
              <Col className="text-center print:hidden"></Col>
              <Col className="text-center">
                {
                  inspectionModel?.inspectionModelItemChildren.items?.[
                    i + 3
                  ].title.split("（")[0]
                }
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={result?.childrenResults[i + 3] ?? "-"}
                  unit={
                    inspectionModel?.inspectionModelItemChildren.items?.[i + 3]
                      .unit
                  }
                  isInputCorrect={isInputCorrect(
                    inspectionModel?.name,
                    result?.childrenResults[i + 3] ?? "-",
                    i + 3
                  )}
                />
              </Col>
              <Col className="text-center">
                {
                  inspectionModel?.inspectionModelItemChildren.items?.[
                    i + 3
                  ].title
                    .split("（")
                    .pop()
                    .split("）")[0]
                }
              </Col>
            </tr>
          ))}
        </TableBody>
      </Table>

      <Table>
        <thead>
          <tr>
            <ColHeader
              id={inspectionModel?.name}
              className="w-10 text-center print:hidden"
            >
              {!isPastInspection && (
                <ResultDropdown
                  openEdit={openEdit}
                  openObs={openObs}
                  selectedItem={inspectionModel}
                  turbineInspection={turbineInspection}
                  selectedResult={result}
                  lastTurbineInspections={lastTurbineInspections}
                  inspection={inspection}
                />
              )}
            </ColHeader>
            <ColHeader className="text-center">気温</ColHeader>
            <ColHeader className="text-center">湿度</ColHeader>
            <ColHeader className="text-center">油温</ColHeader>
          </tr>
        </thead>
        <TableBody>
          <tr>
            <Col className="text-center print:hidden"></Col>
            {[...Array(3)].map((_, i) => (
              <Col key={`y-${i}`} className="text-center">
                <ResultBadge
                  result={result?.childrenResults[i] ?? "-"}
                  unit={
                    inspectionModel?.inspectionModelItemChildren.items?.[i].unit
                  }
                  isInputCorrect={isInputCorrect(
                    inspectionModel?.name,
                    result?.childrenResults[i] ?? "-",
                    i
                  )}
                />
              </Col>
            ))}
          </tr>
        </TableBody>
      </Table>
    </div>
  );
};

export default InsulationResistance;
